<template>
  <div class="booking-divider booking-divider-right booking-payment-widget">
    <div class="booking-content">
      <div class="d-flex flex-column justify-content-center align-items-center h-100 px-3 text-left">
        <div class="w-100">
          <div role="alert" class="alert alert-info alert-icon">
            <div class="alert-content">
              <p class="mb-0">
                Please complete payment to secure your booking. Redirecting to the secure payment page in {{ countdown }} seconds...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LopayWidget',
  props: {
    paymentLink: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      countdown: 3,
      timer: null
    }
  },
  methods: {
    ...mapActions('Authentication', [
      'logout'
    ]),
    startCountdown () {
      this.timer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--
        } else {
          clearInterval(this.timer)
          this.openPaymentLink()
        }
      }, 1000)
    },
    openPaymentLink () {
      window.location.href = this.paymentLink
    }
  },
  created () {
    this.logout()
  },
  mounted () {
    if (this.paymentLink) {
      this.startCountdown()
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>
